<div #idCardContainer
     class=" id-card-container"
     [style.width.rem]="customWidth" >
    <div class=" h-full" id="userAndSignatureCard" style="border: orange dashed 2px;">
        <div class="p-1 flex justify-content-center align-items-center h-full">
            <div class="w-full  py-1 px-2 h-full">
                <div class="flex" style="height: 50% !important;">
                    <div class="w-full  no-line-breaks">
                        <div class="pb-0 " [style.fontSize.em]="customWidth / dynamicNameFontDevideNumber"><span class="font-bold"> Template / Platzhalter</span> <br>{{ name }}
                        </div>
                        <div class="w-full flex flex-column justify-content-center no-line-breaks">
                            <span class="" [style.fontSize.em]="customWidth / 25">{{ optionalLine1 }}</span>
                            <span [style.fontSize.em]="customWidth / 25">{{ optionalLine2 }} {{ currentTime }}</span>
                        </div>
                    </div>

                </div>
                <div class="flex align-items-center py-1" style="height: 50% !important;">
                    <div class="w-3 py-2  flex justify-content-center align-items-center"
                         [innerHTML]="signType| evidenceSvg"></div>
                    <div class="w-6 flex flex-column justify-content-center ">
                        <span class="font-bold" [style.fontSize.em]="customWidth / 30">
                            {{ 'sipo.id-card-component-evidence.' + signType | translate }}
                        </span>
                        <span [style.fontSize.em]="customWidth / 30">
                            {{ 'sipo.signed-on' | translate }} {{appConfig.domain}}
                        </span>
                    </div>
                    <div class="w-3 flex justify-content-center">
                        <img *ngIf="previewUrl"
                             [src]="previewUrl"
                             class="image-stamp"
                             alt="signature as image"
                             />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

